import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import MuiSnackbar from '@mui/material/Snackbar';
import React from 'react';

import { IconButton } from 'Components/IconButton';
import { SnackbarProps } from './snackbar.types';

const autoHideDuration = 5000;

export const Snackbar = ({ open, message, persist = false, onClose, onUndo }: SnackbarProps) => {
	return (
		<MuiSnackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left'
			}}
			open={open}
			autoHideDuration={!persist ? autoHideDuration : undefined}
			onClose={(_event, reason) => {
				if (reason === 'clickaway') {
					return;
				}

				onClose?.();
			}}
			message={message}
			action={
				<>
					{onUndo && (
						<Button
							type='button'
							color='inherit'
							variant='text'
							size='small'
							onClick={() => {
								onUndo?.();
								onClose?.();
							}}
						>
							UNDO
						</Button>
					)}
					{onClose && (
						<IconButton icon={<CloseIcon />} label='Close' color='inherit' size='small' onClick={onClose} />
					)}
				</>
			}
		/>
	);
};
